import React, { Component } from "react";
import styled from "styled-components";
import Section from "../core/Section";
import BackButton from "../core/BackButton";
import { basicInfoData } from "../../data/loaders";
import { processBasicInfo } from "../../data/process";

const PageWrapper = styled.div`
  padding: 10px;
`;

const studentInfoHeaders = [
  "First Name",
  "Middle Initial",
  "Last Name",
  "Suffix",
  "Dob"
];
const mailingHeaders = [
  "Mail Address",
  "Mail Cross St 1",
  "Mail Cross St 2",
  "Mail Apt",
  "Mail City",
  "Mail State",
  "Mail Zip"
];
const pickupHeaders = [
  "Pick Up Address",
  "Pick Up Cross St 1",
  "Pick Up Cross St 2",
  "Pick Up City",
  "Pick Up State",
  "Pick Up Zip"
];
const contactHeaders = [
  "Cell Phone #",
  "Day Phone #",
  "Eve Phone #",
  "Alt Phone #",
  "Text Phone #",
  "OK to Text?",
  "Email Address"
];
const visitorHeaders = ["Visitor Status Y/N?", "Visitor Status Exp"];

class BasicInfoDashboard extends Component {
  state = {
    data: null,
    loading: true,
    error: false
  };
  async componentDidMount() {
    this.props.updateMenu("basicinfo", "Basic Info");
    const basicInfo = await basicInfoData();
    if (basicInfo.length > 0) {
      const data = processBasicInfo(basicInfo);
      this.setState({ data, loading: false });
    }
    if (basicInfo.length === 0) {
      this.setState({ loading: false, error: "Unable to find Student Info." });
    }
  }
  render() {
    const { loading, data, error } = this.state;
    if (loading) return <h4>Loading Basic Info.</h4>;
    if (error) return <h4>{error}</h4>;

    return (
      <PageWrapper>
        <BackButton path="/app/student-dashboard" />
        <Section
          data={data}
          title="Student Info"
          name="student_info"
          headers={studentInfoHeaders}
        />
        <Section
          data={data}
          title="Mailing Address"
          name="mailing"
          headers={mailingHeaders}
        />
        <Section
          data={data}
          title="Pick Up Address"
          name="pickup"
          headers={pickupHeaders}
        />
        <Section
          data={data}
          title="Contact Info"
          name="contact"
          headers={contactHeaders}
        />
        <Section
          data={data}
          title="Visitor Status"
          name="visitor"
          headers={visitorHeaders}
        />
      </PageWrapper>
    );
  }
}

export default BasicInfoDashboard;
